/** Canonical URLs approved in the SEO URL sheet. */
const CANONICAL_SEO_ROUTE_MAP = {
  '/property/residential-bungalows': { category: 'residential', property_type: 'villa', title: 'Bungalows for Rent', h1: 'Bungalows for Rent' },
  '/property/residential/bungalows': { category: 'residential', property_type: 'villa', title: 'Bungalows for Rent', h1: 'Bungalows for Rent' },
  '/property/residential/private-house': { category: 'residential', property_type: 'independent_house', title: 'Private Houses for Rent', h1: 'Private Houses' },
  '/property/coworking-desk': { category: 'commercial', property_type: 'co_working', title: 'Coworking Desks', h1: 'Coworking Desks' },
  '/property/meeting-rooms': { category: 'commercial', property_type: 'meeting_room', title: 'Meeting Rooms', h1: 'Meeting Rooms' },
  '/property/conference-rooms': { category: 'commercial', property_type: 'conference_room', title: 'Conference Rooms', h1: 'Conference Rooms' },
  '/property/event-venues': { category: 'event_venue', title: 'Event Venues', h1: 'Event Venues' },
  '/property/banquet-halls': { category: 'event_venue', property_type: 'banquet_hall', title: 'Banquet Halls', h1: 'Banquet Halls' },
  '/property/hotel-ball-rooms': { category: 'event_venue', property_type: 'hotel_ballroom', title: 'Hotel Ballrooms', h1: 'Hotel Ballrooms' },
  '/property/hotel-ballrooms': { category: 'event_venue', property_type: 'hotel_ballroom', title: 'Hotel Ballrooms', h1: 'Hotel Ballrooms' },
  '/property/wedding-venues': { category: 'event_venue', property_type: 'wedding_venue', title: 'Wedding Venues', h1: 'Wedding Venues' },
  '/property/workspaces-in-nashik': { category: 'commercial', city: 'Nashik', title: 'Workspaces in Nashik', h1: 'Workspaces in Nashik' },
  '/property/private-offices': { category: 'commercial', property_type: 'private_office', title: 'Private Offices', h1: 'Private Offices' },
  '/property/private-offices-in-nashik': { category: 'commercial', property_type: 'private_office', city: 'Nashik', title: 'Private Offices in Nashik', h1: 'Private Offices in Nashik' },
  '/property/villas-in-trimbakeshwar': { category: 'residential', property_type: 'villa', city: 'Trimbakeshwar', title: 'Villas in Trimbakeshwar', h1: 'Villas in Trimbakeshwar' },
  '/property/pool-villas-in-trimbakeshwar': { category: 'residential', property_type: 'villa', city: 'Trimbakeshwar', title: 'Pool Villas in Trimbakeshwar', h1: 'Pool Villas in Trimbakeshwar' },
  '/property/office-suites-in-trimbakeshwar': { category: 'commercial', property_type: 'private_office', city: 'Trimbakeshwar', title: 'Office Suites in Trimbakeshwar', h1: 'Office Suites in Trimbakeshwar' },
  '/property/premium-offices-in-nashik': { category: 'commercial', property_type: 'private_office', city: 'Nashik', title: 'Premium Offices in Nashik', h1: 'Premium Offices in Nashik' },
  '/property/villas-in-igatpuri': { category: 'residential', property_type: 'villa', city: 'Igatpuri', title: 'Villas in Igatpuri', h1: 'Villas in Igatpuri' },
  '/property/corporate-space-in-igatpuri': { category: 'commercial', city: 'Igatpuri', title: 'Corporate Spaces in Igatpuri', h1: 'Corporate Spaces in Igatpuri' },
  '/property/residential-stay': { category: 'residential', title: 'Residential Stays', h1: 'Residential Stays' },
  '/property/residential/family-stay-in-trimbak': { category: 'residential', city: 'Trimbakeshwar', title: 'Family Stays in Trimbak', h1: 'Family Stays in Trimbak' },
  '/property/residential/holiday-homes-in-igatpuri': { category: 'residential', city: 'Igatpuri', title: 'Holiday Homes in Igatpuri', h1: 'Holiday Homes in Igatpuri' },
  '/property/residential/nature-stay-in-bhandardara': { category: 'residential', city: 'Bhandardara', title: 'Nature Stays in Bhandardara', h1: 'Nature Stays in Bhandardara' },
};

/** Mapping table of clean SEO-friendly property URLs to filter parameters. */
export const SEO_ROUTE_MAP = {
  ...CANONICAL_SEO_ROUTE_MAP,
  '/property/villas': {
    category: 'residential',
    property_type: 'villa',
    title: 'Villas for Rent in Nashik & Nearby Destinations',
    description: 'Find villas for your next getaway across Nashik, Igatpuri, Trimbakeshwar and Bhandardara. Browse stays and choose your ideal villa.',
    h1: 'Villas for Rent in Nashik & Nearby'
  },
  '/property/villas-in-nashik': {
    category: 'residential',
    property_type: 'villa',
    city: 'Nashik',
    title: 'Villas in Nashik for Weekend & Family Stays',
    description: 'Discover villas in Nashik for weekends, family holidays and group stays. Browse available properties and find a stay that fits your trip.',
    h1: 'Villas in Nashik'
  },
  '/property/villas-in-trimbakeshwar': {
    category: 'residential',
    property_type: 'villa',
    city: 'Trimbakeshwar',
    title: 'Villas in Trimbakeshwar for Family & Group Stays',
    description: 'Explore villas in Trimbakeshwar for family trips, group stays and peaceful getaways near Nashik. Find and book your ideal stay.',
    h1: 'Villas in Trimbakeshwar'
  },
  '/property/villas-in-igatpuri': {
    category: 'residential',
    property_type: 'villa',
    city: 'Igatpuri',
    title: 'Villas in Igatpuri for Weekend Getaways',
    description: 'Find villas in Igatpuri for weekend getaways, family trips and group stays. Explore available properties and plan your next escape.',
    h1: 'Villas in Igatpuri'
  },
  '/property/villas-in-bhandardara': {
    category: 'residential',
    property_type: 'villa',
    city: 'Bhandardara',
    title: 'Villas in Bhandardara for Scenic Getaways',
    description: 'Discover villas in Bhandardara surrounded by nature, hills and scenic landscapes. Explore stays for your next weekend getaway.',
    h1: 'Villas in Bhandardara'
  },
  '/property/luxury-villas-in-nashik': {
    category: 'residential',
    property_type: 'villa',
    city: 'Nashik',
    min_price: '50000',
    title: 'Luxury Villas in Nashik for Premium Stays',
    description: 'Explore luxury villas in Nashik for premium family holidays, celebrations and group getaways. Find a villa that matches your stay.',
    h1: 'Luxury Villas in Nashik'
  },
  '/property/weekend-villas-in-igatpuri': {
    category: 'residential',
    property_type: 'villa',
    city: 'Igatpuri',
    title: 'Weekend Villas in Igatpuri for a Quick Getaway',
    description: 'Plan a relaxing weekend with villas in Igatpuri. Explore spacious stays for couples, families and groups near Nashik.',
    h1: 'Weekend Villas in Igatpuri'
  },
  '/property/scenic-villas-in-bhandardara': {
    category: 'residential',
    property_type: 'villa',
    city: 'Bhandardara',
    title: 'Scenic Villas in Bhandardara for Nature Getaways',
    description: "Stay close to Bhandardara's scenic landscapes with comfortable villas for weekend trips, family holidays and group getaways.",
    h1: 'Scenic Villas in Bhandardara'
  },
  '/property/residential': {
    category: 'residential',
    title: 'Residential Stays in Nashik & Nearby Areas',
    description: 'Explore residential stays including villas, apartments, homestays, farmhouses and private homes across Nashik and nearby destinations.',
    h1: 'Residential Stays in Nashik & Nearby'
  },
  '/property/residential/': {
    category: 'residential',
    title: 'Residential Stays in Nashik & Nearby Areas',
    description: 'Explore residential stays including villas, apartments, homestays, farmhouses and private homes across Nashik and nearby destinations.',
    h1: 'Residential Stays in Nashik & Nearby'
  },
  '/property/residential/homestay-in-nashik': {
    category: 'residential',
    city: 'Nashik',
    title: 'Homestays in Nashik for Comfortable Local Stays',
    description: 'Find homestays in Nashik for family trips, weekend breaks and longer stays. Explore comfortable properties and plan your visit.',
    h1: 'Homestays in Nashik'
  },
  '/property/residential/apartment-in-nashik': {
    category: 'residential',
    property_type: 'apartment',
    city: 'Nashik',
    title: 'Apartments in Nashik for Short & Extended Stays',
    description: 'Find apartments in Nashik for short stays, family trips and extended visits. Browse available properties and choose your stay.',
    h1: 'Apartments in Nashik'
  },
  '/property/residential/farmhouse-in-nashik': {
    category: 'residential',
    property_type: 'farmhouse',
    city: 'Nashik',
    title: 'Farmhouses in Nashik for Weekend & Group Stays',
    description: 'Discover farmhouses in Nashik for weekend getaways, family gatherings and group stays. Explore available properties and plan your trip.',
    h1: 'Farmhouses in Nashik'
  },
  '/property/residential/holidayhomes-in-igatpuri': {
    category: 'residential',
    city: 'Igatpuri',
    title: 'Holiday Homes in Igatpuri for Weekend Getaways',
    description: 'Find holiday homes in Igatpuri for family holidays, weekend breaks and group getaways. Explore comfortable stays near Nashik.',
    h1: 'Holiday Homes in Igatpuri'
  },
  '/property/residential/homestay-in-igatpuri': {
    category: 'residential',
    city: 'Igatpuri',
    title: 'Homestays in Igatpuri for Relaxing Getaways',
    description: 'Explore homestays in Igatpuri for weekend trips, family stays and peaceful getaways. Find a comfortable place for your next visit.',
    h1: 'Homestays in Igatpuri'
  },
  '/property/residential/familystay-in-trimbak': {
    category: 'residential',
    city: 'Trimbakeshwar',
    title: 'Family Stays in Trimbakeshwar for Comfortable Trips',
    description: 'Find family-friendly stays in Trimbakeshwar for temple visits, weekend trips and family holidays. Explore available properties.',
    h1: 'Family Stays in Trimbakeshwar'
  },
  '/property/residential/apartment-in-trimbak': {
    category: 'residential',
    property_type: 'apartment',
    city: 'Trimbakeshwar',
    title: 'Apartments in Trimbakeshwar for Short Stays',
    description: 'Explore apartments in Trimbakeshwar for family trips, temple visits and short stays. Find a convenient property for your visit.',
    h1: 'Apartments in Trimbakeshwar'
  },
  '/property/residential/naturestay-in-bhandardara': {
    category: 'residential',
    city: 'Bhandardara',
    title: 'Nature Stays in Bhandardara for Peaceful Getaways',
    description: 'Discover nature stays in Bhandardara for weekend escapes, family trips and relaxing holidays surrounded by scenic landscapes.',
    h1: 'Nature Stays in Bhandardara'
  },
  '/property/residential/banglows': {
    category: 'residential',
    property_type: 'villa',
    title: 'Bungalows for Rent in Nashik & Nearby Destinations',
    description: 'Explore bungalows for weekend trips, family holidays and group stays across Nashik and nearby destinations. Find your ideal stay.',
    h1: 'Bungalows for Rent in Nashik & Nearby'
  },
  '/property/residential/apartment': {
    category: 'residential',
    property_type: 'apartment',
    title: 'Apartments for Short Stays in Nashik & Nearby',
    description: 'Browse apartments for short stays, family trips and extended visits across Nashik and nearby destinations.',
    h1: 'Apartments for Short Stays'
  },
  '/property/residential/studio': {
    category: 'residential',
    property_type: 'studio',
    title: 'Studio Stays in Nashik & Nearby Destinations',
    description: 'Find studio stays for solo trips, couples and short visits across Nashik and nearby destinations. Explore available properties.',
    h1: 'Studio Stays in Nashik & Nearby'
  },
  '/property/residential/privatehouse': {
    category: 'residential',
    property_type: 'independent_house',
    title: 'Private Houses for Family & Group Stays',
    description: 'Discover private houses for family holidays, group trips and weekend getaways across Nashik and nearby destinations.',
    h1: 'Private Houses for Family & Group Stays'
  },
  '/property/residential/farmhouse': {
    category: 'residential',
    property_type: 'farmhouse',
    title: 'Farmhouses for Weekend & Group Stays',
    description: 'Explore farmhouses for weekend getaways, family gatherings and group trips across Nashik and nearby destinations.',
    h1: 'Farmhouses for Weekend & Group Stays'
  },
  '/event-venues': {
    category: 'event_venue',
    title: 'Event Venues in Nashik & Nearby Destinations',
    description: 'Discover event venues for weddings, celebrations, corporate events and gatherings across Nashik and nearby destinations.',
    h1: 'Event Venues in Nashik & Nearby'
  },
  '/event-venues/wedding-venues': {
    category: 'event_venue',
    title: 'Wedding Venues in Nashik & Nearby Destinations',
    description: 'Find wedding venues for intimate ceremonies, large celebrations and destination weddings across Nashik and nearby areas.',
    h1: 'Wedding Venues in Nashik & Nearby'
  },
  '/event-venues/wedding-venues-in-nashik': {
    category: 'event_venue',
    city: 'Nashik',
    title: 'Wedding Venues in Nashik for Your Special Day',
    description: 'Explore wedding venues in Nashik for ceremonies, receptions and celebrations. Compare venue options and plan your wedding.',
    h1: 'Wedding Venues in Nashik'
  },
  '/event-venues/wedding-venues-in-igatpuri': {
    category: 'event_venue', city: 'Igatpuri',
    title: 'Wedding Venues in Igatpuri for Destination Weddings',
    description: 'Discover wedding venues in Igatpuri for destination weddings, family celebrations and memorable events. Explore your venue options.',
    h1: 'Wedding Venues in Igatpuri'
  },
  '/event-venues/banquet-halls': {
    category: 'event_venue',
    title: 'Banquet Halls in Nashik & Nearby Areas',
    description: 'Find banquet halls for weddings, receptions, parties, corporate events and social gatherings across Nashik and nearby destinations.',
    h1: 'Banquet Halls in Nashik & Nearby'
  },
  '/event-venues/banquet-halls-in-nashik': {
    category: 'event_venue', city: 'Nashik',
    title: 'Banquet Halls in Nashik for Weddings & Events',
    description: 'Explore banquet halls in Nashik for weddings, receptions, parties and corporate events. Find a venue that fits your requirements.',
    h1: 'Banquet Halls in Nashik'
  },
  '/event-venues/hotel-ballrooms': {
    category: 'event_venue',
    title: 'Hotel Ballrooms in Nashik for Weddings & Events',
    description: 'Discover hotel ballrooms for weddings, receptions, corporate events and private celebrations in Nashik and nearby areas.',
    h1: 'Hotel Ballrooms in Nashik & Nearby'
  },
  '/event-venues/corporate-event-venues-in-nashik': {
    category: 'event_venue', city: 'Nashik',
    title: 'Corporate Event Venues in Nashik for Business Events',
    description: 'Find corporate event venues in Nashik for meetings, conferences, team events and business gatherings. Explore suitable venue options.',
    h1: 'Corporate Event Venues in Nashik'
  },
  '/event-venues/event-lawns-in-nashik': {
    category: 'event_venue', city: 'Nashik',
    title: 'Event Lawns in Nashik for Weddings & Celebrations',
    description: 'Explore event lawns in Nashik for weddings, receptions, parties and large celebrations. Find a venue for your next event.',
    h1: 'Event Lawns in Nashik'
  },
  '/event-venues/celebration-venues-in-igatpuri': {
    category: 'event_venue', city: 'Igatpuri',
    title: 'Celebration Venues in Igatpuri for Special Events',
    description: 'Find celebration venues in Igatpuri for birthdays, parties, family functions and special occasions. Explore venue options today.',
    h1: 'Celebration Venues in Igatpuri'
  },
  '/event-venues/resorts-and-lawns-in-trimbakeshwar': {
    category: 'event_venue', city: 'Trimbakeshwar',
    title: 'Resorts & Lawns in Trimbakeshwar for Events',
    description: 'Discover resorts and event lawns in Trimbakeshwar for weddings, celebrations, family gatherings and special events.',
    h1: 'Resorts & Lawns in Trimbakeshwar'
  },
  '/event-venues/resorts-in-bhandardara': {
    category: 'event_venue', city: 'Bhandardara',
    title: 'Resorts in Bhandardara for Events & Getaways',
    description: 'Explore resorts in Bhandardara for celebrations, group events, family gatherings and scenic getaways near Nashik.',
    h1: 'Resorts in Bhandardara'
  },
  '/property/workspaces': {
    category: 'commercial',
    city: 'Nashik',
    title: 'Workspaces in Nashik for Work, Meetings & Teams',
    description: 'Find coworking spaces, private offices, meeting rooms and team spaces in Nashik for flexible business needs.',
    h1: 'Workspaces in Nashik'
  },
  '/property/coworking-spaces': {
    category: 'commercial',
    city: 'Nashik',
    title: 'Coworking Spaces in Nashik & Nearby Areas',
    description: 'Discover flexible coworking spaces for freelancers, startups, remote workers and businesses in Nashik and nearby areas.',
    h1: 'Coworking Spaces in Nashik'
  },
  '/property/coworking-spaces-in-nashik': {
    category: 'commercial', city: 'Nashik',
    title: 'Coworking Spaces in Nashik for Flexible Work',
    description: 'Find coworking spaces in Nashik with flexible options for individuals, startups, remote teams and growing businesses.',
    h1: 'Coworking Spaces in Nashik'
  },
  '/property/private-offices': {
    category: 'commercial', city: 'Nashik',
    title: 'Private Offices for Rent in Nashik',
    description: 'Find private offices in Nashik for focused work, teams, startups and businesses looking for flexible workspace solutions.',
    h1: 'Private Offices in Nashik'
  },
  '/property/private-offices-in-nashik': {
    category: 'commercial', city: 'Nashik',
    title: 'Private Offices in Nashik for Teams & Businesses',
    description: 'Explore private offices in Nashik for startups, teams and businesses. Find a workspace that matches your requirements.',
    h1: 'Private Offices in Nashik'
  },
  '/property/meeting-rooms': {
    category: 'commercial', city: 'Nashik',
    title: 'Meeting Rooms in Nashik for Business Meetings',
    description: 'Find professional meeting rooms in Nashik for client meetings, interviews, workshops and team discussions.',
    h1: 'Meeting Rooms in Nashik'
  },
  '/property/meeting-rooms-in-nashik': {
    category: 'commercial', city: 'Nashik',
    title: 'Meeting Rooms in Nashik for Meetings & Workshops',
    description: 'Book meeting rooms in Nashik for business meetings, workshops, interviews and team sessions. Explore available spaces.',
    h1: 'Meeting Rooms in Nashik'
  },
  '/property/team-spaces': {
    category: 'commercial', city: 'Nashik',
    title: 'Team Spaces in Nashik for Collaborative Work',
    description: 'Explore team spaces in Nashik designed for meetings, collaboration, project work and growing teams.',
    h1: 'Team Spaces in Nashik'
  },
  '/property/team-spaces-in-nashik': {
    category: 'commercial', city: 'Nashik',
    title: 'Team Spaces in Nashik for Growing Businesses',
    description: 'Find flexible team spaces in Nashik for startups, project teams and businesses. Explore workspace options for your team.',
    h1: 'Team Spaces in Nashik'
  },
  '/property/corporate-spaces': {
    category: 'commercial', city: 'Nashik',
    title: 'Corporate Spaces in Nashik for Business Needs',
    description: 'Discover professional corporate spaces in Nashik for meetings, team activities, events and business requirements.',
    h1: 'Corporate Spaces in Nashik'
  }
};

export const SEO_BROWSE_PATHS = Object.keys(SEO_ROUTE_MAP);

export const LEGACY_SEO_REDIRECTS = {
  '/property/residential/bungalows': '/property/residential-bungalows',
  '/property/hotel-ball-rooms': '/property/hotel-ballrooms',
  '/property/residential': '/property/residential/bungalows',
  '/property/residential/': '/property/residential/bungalows',
  '/property/residential/banglows': '/property/residential/bungalows',
  '/property/residential/privatehouse': '/property/residential/private-house',
  '/property/workspaces/': '/property/coworking-desk',
  '/property/coworking-spaces': '/property/coworking-desk',
  '/event-venues': '/property/event-venues',
  '/event-venues/banquet-halls': '/property/banquet-halls',
  '/event-venues/hotel-ballrooms': '/property/hotel-ball-rooms',
  '/event-venues/wedding-venues': '/property/wedding-venues',
  '/property/residential/familystay-in-trimbak': '/property/residential/family-stay-in-trimbak',
  '/property/residential/holidayhomes-in-igatpuri': '/property/residential/holiday-homes-in-igatpuri',
  '/property/residential/naturestay-in-bhandardara': '/property/residential/nature-stay-in-bhandardara',
};

const CITY_NAME_MAP = {
  nashik: 'Nashik',
  mumbai: 'Mumbai',
  pune: 'Pune',
  lonavala: 'Lonavala',
  igatpuri: 'Igatpuri',
  trimbakeshwar: 'Trimbakeshwar',
  bhandardara: 'Bhandardara',
  bhnadardara: 'Bhandardara',
  trimbak: 'Trimbakeshwar',
  karjat: 'Karjat',
  mahabaleshwar: 'Mahabaleshwar',
  alibaug: 'Alibaug',
  goa: 'Goa',
  bangalore: 'Bangalore'
};

const capitalizeCity = (slug) => {
  if (!slug) return '';
  const lower = slug.toLowerCase();
  if (CITY_NAME_MAP[lower]) return CITY_NAME_MAP[lower];
  return slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};

/**
 * Returns preset filter criteria if path matches a known clean SEO URL or dynamic SEO pattern.
 */
export const getSeoRoutePreset = (pathname) => {
  if (!pathname) return null;
  const normalized = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;

  if (SEO_ROUTE_MAP[pathname]) return SEO_ROUTE_MAP[pathname];
  if (SEO_ROUTE_MAP[normalized]) return SEO_ROUTE_MAP[normalized];

  // Dynamic pattern resolution
  if (normalized.startsWith('/property/')) {
    const slug = normalized.replace('/property/', '').toLowerCase();

    // Event Venues pattern: /property/event-venues-in-cityname
    const eventMatch = slug.match(/^event-venues-in-([a-z0-9-]+)$/i);
    if (eventMatch) {
      const city = capitalizeCity(eventMatch[1]);
      return {
        category: 'event_venue',
        city,
        title: `Event Venues in ${city} | X-Space360`,
        description: `Book banquet halls, rooftops, and event venues in ${city}.`
      };
    }

    // Commercial pattern: /property/commercial-spaces-in-cityname
    const commMatch = slug.match(/^commercial-spaces-in-([a-z0-9-]+)$/i);
    if (commMatch) {
      const city = capitalizeCity(commMatch[1]);
      return {
        category: 'commercial',
        city,
        title: `Commercial Spaces in ${city} | X-Space360`,
        description: `Rent offices, co-working desks, and conference rooms in ${city}.`
      };
    }

    // Villas pattern: /property/villas-in-cityname
    const villaMatch = slug.match(/^villas-in-([a-z0-9-]+)$/i);
    if (villaMatch) {
      const city = capitalizeCity(villaMatch[1]);
      return {
        category: 'residential',
        property_type: 'villa',
        city,
        title: `Villas in ${city} | X-Space360`,
        description: `Find top-rated luxury villas and private stays in ${city}.`
      };
    }

    // Homestay pattern: /property/residential/homestay-in-cityname
    const homestayMatch = slug.match(/^(?:residential\/)?([a-z0-9-]+)-in-([a-z0-9-]+)$/i);
    if (homestayMatch) {
      const typePart = homestayMatch[1];
      const city = capitalizeCity(homestayMatch[2]);
      let property_type = '';
      if (typePart.includes('apartment')) property_type = 'apartment';
      else if (typePart.includes('farmhouse')) property_type = 'farmhouse';
      else if (typePart.includes('villa')) property_type = 'villa';

      return {
        category: 'residential',
        property_type,
        city,
        search: city,
        title: `Stays in ${city} | X-Space360`,
        description: `Comfortable homestays and family stays near ${city}.`
      };
    }

    // Generic category in city pattern: /property/:cat-in-:city
    const genericMatch = slug.match(/^([a-z0-9-]+)-in-([a-z0-9-]+)$/i);
    if (genericMatch) {
      const catPart = genericMatch[1];
      const city = capitalizeCity(genericMatch[2]);
      let category = 'residential';
      let property_type = '';

      if (catPart.includes('event') || catPart.includes('venue') || catPart.includes('banquet')) {
        category = 'event_venue';
      } else if (catPart.includes('commercial') || catPart.includes('office') || catPart.includes('work')) {
        category = 'commercial';
      } else if (catPart.includes('apartment')) {
        category = 'residential';
        property_type = 'apartment';
      } else if (catPart.includes('farmhouse')) {
        category = 'residential';
        property_type = 'farmhouse';
      } else if (catPart.includes('villa')) {
        category = 'residential';
        property_type = 'villa';
      }

      return {
        category,
        property_type,
        city,
        search: city,
        title: `Spaces in ${city} | X-Space360`,
        description: `Explore curated spaces in ${city}.`
      };
    }
  }

  return null;
};

/**
 * Returns clean SEO URL for a given filter object.
 */
export const getSeoUrlForFilters = (filters = {}) => {
  const category = (filters.category || '').toLowerCase();
  const city = (filters.city || '').trim();
  const propType = (filters.property_type || '').toLowerCase();
  const minPrice = String(filters.min_price || '');

  // 1. Check exact map
  for (const [route, preset] of Object.entries(SEO_ROUTE_MAP)) {
    if (
      (preset.category || '') === category &&
      (preset.property_type || '') === propType &&
      (preset.city || '').toLowerCase() === city.toLowerCase() &&
      String(preset.min_price || '') === minPrice
    ) {
      return route;
    }
  }

  const citySlug = city ? city.toLowerCase().replace(/[^a-z0-9]+/g, '-') : '';

  // 2. Dynamic Clean URLs
  if (category === 'residential') {
    if (propType === 'villa') return citySlug ? `/property/villas-in-${citySlug}` : `/property/villas`;
    if (propType === 'apartment') return citySlug ? `/property/residential/apartment-in-${citySlug}` : `/property/residential/apartment`;
    if (propType === 'farmhouse') return citySlug ? `/property/residential/farmhouse-in-${citySlug}` : `/property/residential/farmhouse`;
    if (citySlug) return `/property/residential/homestay-in-${citySlug}`;
    return `/property/residential`;
  }

  if (citySlug) {
    if (propType === 'villa') return `/property/villas-in-${citySlug}`;
    return `/property/residential/homestay-in-${citySlug}`;
  }

  return '/guest/browse';
};
